import { useRef } from 'react';

export function usePrev<T>(val: T): T {
  const ref = useRef(val);
  const prev = ref.current;
  ref.current = val;

  return prev;
}
